<template>
  <div class="home-sale-layout w1200 mt20">
    <div class="hd">
      <ul class="tabs-nav">
        <li class="tabs-selected on"><i class="arrow"></i>
          <h3>限时秒杀</h3>
        </li>
        <li class=""><i class="arrow"></i>
          <h3>今日特价</h3>
        </li>
        <li class=""><i class="arrow"></i>
          <h3>限时优惠</h3>
        </li>
        <li class=""><i class="arrow"></i>
          <h3>商品推荐</h3>
        </li>
      </ul>
    </div>
    <div class="bd tabs-panel">
      <!-- 限时秒杀 -->
      <ul style="display: block;">
        <div class="activity-scroll seckill_scroll w1200">
          <div class="bd">
            <ul>
              <div class="">
                <div class="li">
                  <li v-for="(item, index) in seckill_list" :key="index">
                    <router-link :to="{
                      path:'/seckill/detail/' +item.id
                    }">
                      <dl>
                        <dd class="goods-thumb">

                          <a href="javascript:void(0)">
                            <img class="lazyload" :data-original="item.image" :alt="item.title" :src="item.image"
                              style="display: inline;">
                          </a>


                        </dd>
                        <dt class="goods-name">
                          <a href="javascript:void(0)" :title="item.title">{{item.title}}</a></dt>
                        <dd class="goods-price">
                          <em v-if="item.price == '请先登录'">请先登录</em>
                          <em v-else>￥{{item.price}}</em>
                        </dd>
                      </dl>
                    </router-link>
                  </li>
                </div>
              </div>
            </ul>
            <!-- <a class="ctrl prev" href="javascript:void(0)">&lt;</a>
            <a class="ctrl next" href="javascript:void(0)">&gt;</a> -->
          </div>
        </div>
      </ul>

      <!-- 今日特价 -->
      <ul style="display: none;">
        <div class="activity-scroll special_scroll w1200">
          <div class="bd">
            <ul>
              <div class="">
                <div class="li">
                  <li v-for="(item, index) in special_list" :key="index">
                    <router-link :to="{
                      path:'/special/detail/' +item.id
                    }">
                      <dl>
                        <dd class="goods-thumb">
                          <a href="javascript:void(0)">
                            <img class="lazyload" :data-original="item.image" :alt="item.title" :src="item.image"
                              style="display: inline;">
                          </a>
                        </dd>
                        <dt class="goods-name"><a href="javascript:void(0)" :title="item.title">{{item.title}}</a></dt>
                        <dd class="goods-price">
                          <em v-if="item.price == '请先登录'">请先登录</em>
                          <em v-else>￥{{item.price}}</em>
                        </dd>
                      </dl>
                    </router-link>

                  </li>
                </div>
              </div>
            </ul>
            <!-- <a class="ctrl prev" href="javascript:void(0)">&lt;</a>
            <a class="ctrl next" href="javascript:void(0)">&gt;</a> -->
          </div>
        </div>
      </ul>

      <!-- 限时优惠-->
      <ul style="display: none;">
        <div class="activity-scroll discount_scroll w1200">
          <div class="bd">
            <ul>
              <div class="">
                <div class="li">
                  <li v-for="(item, index) in discount_list" :key="index">
                    <router-link :to="{
                      path:'/discount/detail/' +item.id
                    }">
                      <dl>
                        <dd class="goods-thumb">
                          <a href="javascript:void(0)">
                            <img class="lazyload" :data-original="item.image" :alt="item.title" :src="item.image"
                              style="display: inline;">
                          </a>
                        </dd>
                        <dt class="goods-name"><a href="javascript:void(0)" :title="item.title">{{item.title}}</a></dt>
                        <dd class="goods-price">
                          <em v-if="item.price == '请先登录'">请先登录</em>
                          <em v-else>￥{{item.price}}</em>
                        </dd>
                      </dl>
                    </router-link>
                  </li>
                </div>
              </div>
            </ul>
            <!-- <a class="ctrl prev" href="javascript:void(0)">&lt;</a>
            <a class="ctrl next" href="javascript:void(0)">&gt;</a> -->
          </div>
        </div>
      </ul>

      <!-- 商品推荐 -->
      <ul style="display: none;">
        <div class="activity-scroll recommend_scroll w1200">
          <div class="bd">
            <ul>
              <div class="">
                <div class="li">
                  <li v-for="(item, index) in recommend_list" :key="index">
                    <dl>
                      <dd class="goods-thumb">
                        <router-link to="">
                          <a href="javascript:void(0)">
                            <img class="lazyload" :data-original="item.image" :alt="item.title" :src="item.image"
                              style="display: inline;">
                          </a>
                        </router-link>

                      </dd>
                      <dt class="goods-name"><a href="javascript:void(0)" :title="item.title">{{item.title}}</a></dt>
                      <dd class="goods-price">
                        <em v-if="item.price == '请先登录'">请先登录</em>
                        <em v-else>￥{{item.price}}</em>
                      </dd>
                    </dl>
                  </li>
                </div>
              </div>
            </ul>
            <!-- <a class="ctrl prev" href="javascript:void(0)">&lt;</a>
            <a class="ctrl next" href="javascript:void(0)">&gt;</a> -->
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
  import '@/assets/plugins/jquery.SuperSlide.2.1.1.js'
  import {
    getSeckillList,
    getDiscountList,
    getSpecialList
  } from '@/api/activity.js'
  export default {
    name: 'ActivityArea',
    data() {
      return {
        recommend_list: [],
        seckill_list: [],
        special_list: [],
        discount_list: [],
      }
    },
    methods: {
      getData() {
        var that = this
        getSeckillList().then((res) => {
          that.seckill_list = res.data
          that.$nextTick(function () {

            jQuery(".seckill_scroll").slide({
              mainCell: ".bd .li",
              autoPage: true,
              autoPlay: true,
              delayTime: 1000,
              effect: "left",
              interTime: 2000,
              vis: 6
            });

          })
        })
        getSpecialList().then((res) => {
          that.special_list = res.data
          that.$nextTick(function () {

            jQuery(".special_scroll").slide({
              mainCell: ".bd .li",
              autoPage: true,
              autoPlay: true,
              delayTime: 1000,
              effect: "left",
              interTime: 2000,
              vis: 6
            });

          })
        })
        getDiscountList().then((res) => {
          that.discount_list = res.data
          that.$nextTick(function () {

            jQuery(".discount_scroll").slide({
              mainCell: ".bd .li",
              autoPage: true,
              autoPlay: true,
              delayTime: 1000,
              effect: "left",
              interTime: 2000,
              vis: 6
            });

          })
        })
      }
    },
    mounted() {
      var that = this
      this.getData()
      this.$nextTick(function () {
        jQuery(".home-sale-layout").slide({
          autoPlay: false,
        });
      })
    },
  }
</script>

<style scoped>
  .activity-sale-layout {
    margin: 20px auto;
    height: 300px;
  }

  .activity-sale-layout .tabs-panel ul li {
    height: 300px;
  }

  .activity-sale-layout .tabs-panel ul {
    height: 300px;
  }

  .activity-scroll .ctrl {
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -31px;
    z-index: 9;
    width: 30px;
    height: 62px;
    line-height: 62px;
    color: white;
    text-align: center;
    font-size: 36px;
    font-family: simsun;
    font-weight: 500;
    background: #000;
    filter: alpha(opacity=50);
    -moz-opacity: 0.5;
    -khtml-opacity: 0.5;
    opacity: 0.5;
  }

  .activity-scroll .ctrl:hover {
    color: #fff;
    filter: alpha(opacity=80);
    -moz-opacity: 0.8;
    -khtml-opacity: 0.8;
    opacity: 0.8;
  }

  .activity-scroll .prev {
    position: absolute;
    left: 0%;
  }

  .activity-scroll .next {
    position: absolute;
    right: 0%;
  }
</style>
